import {css} from 'lit';
export const styles = css`:host{position:relative;white-space:nowrap;text-align:center;display:inline-block}`;
export default styles;
